import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * @description 'System' network resource on the public API, which exposes endpoints like health check.
 */
@Injectable()
export class SystemProvider { 
  private assetURL = '/assets/data/';

  constructor(private httpClient: HttpClient) { }

  public async getAppReleaseInfo() {
    const json = await this.readAssetData('version.json').toPromise();
    const data = JSON.parse(json);
    let out = '<h6>Version: <b>' + data.version + '</b>, Build: <b>#' + data.build + '</b> <br> Tag:<b> ' + data.tag + '</b>, Branch:<b> ' + data.branch + '</b> <p><h6>' ;
    return out;
  }

  public readAssetData(fileName: string) {
    const url = this.assetURL + fileName;
    return this.httpClient.get(url, { responseType: 'text' });
  }

}


// WEBPACK FOOTER //
// ./src/providers/system/system.ts